import serviceClient from '../../service-client/service-client';
import site from '../../site';
import hooks from '../../hooks';
import errorTypes from '../../errors/constants/error-types';
import createSavingActions from '../utils/create-saving-actions';
import actualizeInitialData from '../utils/actualize-intial-data';
import constants from '../constants';
import setStatus from '../actions/set-status';
import getStatus from '../selectors/status';
import catchError from '../../errors/operations/catch-error';
import getReadOnlyStatus from '../../read-only/selectors/read-only';

const { statuses } = constants;

let resetTimeout;

/**
 * NEVER PASS `externalActions` TO THIS FUNCTION.
 *
 * This workaround ensures that the save process is handled in a single place.
 * The `apiClient.saveSite` call is also used in other areas, such as
 * the saving manager.
 * Currently, we have unified save handling approach, but to maintain
 * previous functionality, we must pass `externalActions` to the thunk
 * from the places, where we want to avoid to save all diff.
 */
const save = (externalActions) => async (dispatch, getState) => {
  let state = getState();
  const status = getStatus(state);
  const readOnlyStatus = getReadOnlyStatus(state);

  if (readOnlyStatus) {
    catchError(null, errorTypes.READ_ONLY_ERROR);
    return null;
  }

  if (!externalActions && status === statuses.SAVED) {
    return null;
  }

  state = getState();

  const actionsToSave = externalActions || createSavingActions(state);

  if (actionsToSave.length === 0) {
    return null;
  }

  const siteId = site.selectors.getSiteId(state);
  const lastAppliedMigrationId = site.selectors.getLastAppliedMigrationId(state);
  const apiClient = serviceClient.get();
  let saveResponse;

  hooks.handlers.onBeforeSiteSave();
  dispatch(setStatus(statuses.SAVING));

  clearTimeout(resetTimeout);
  resetTimeout = setTimeout(() => {
    dispatch(setStatus(statuses.UNSAVED));
  }, 120000);

  try {
    saveResponse = await apiClient.saveSite(siteId, {
      actions: actionsToSave,
      lastAppliedMigrationId,
    });

    if (!externalActions) {
      actualizeInitialData(state);
    }
  } catch (e) {
    const actionsString = JSON.stringify(actionsToSave, (key, value) => {
      // Remove asset`s content from actions to avoid sending it to Sentry
      if (key === 'content') return undefined;
      return value;
    });

    catchError(e, errorTypes.SAVING_ERROR, { actions: actionsString });

    dispatch(setStatus(statuses.ERROR));
    throw e;
  }

  if (saveResponse && saveResponse.status === 200) {
    hooks.handlers.onAfterSiteSave();
  }

  state = getState();

  if (getStatus(state) !== statuses.UNSAVED) {
    dispatch(setStatus(statuses.SAVED));
  }

  clearTimeout(resetTimeout);

  return saveResponse;
};

export default save;
